import Button from "@components/_Layout/Controls/Button";
import InputLabel from "@components/_Layout/Controls/InputLabel";
import InputText from "@components/_Layout/Controls/InputText";
import React from "react";

type BaseInputDiscountProps = {
  value: string;
  setValue: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  isSubmitting: boolean;
  placeholder?: string;
  btnSubmitText?: string;
  onFormChange?: () => void;
};

export const BaseInputDiscount: React.FC<BaseInputDiscountProps> = ({
  value,
  setValue,
  onSubmit,
  isSubmitting,
  placeholder,
  btnSubmitText,
  onFormChange,
}) => {
  return (
    <form onChange={onFormChange} onSubmit={onSubmit}>
      <div>
        <div className="tw-flex">
          <InputText
            placeholder={placeholder}
            shape="default"
            required
            value={value}
            onChange={(e) => setValue(e.target.value)}
            additionalClassname="tw-rounded-l-full tw-rounded-r-none tw-flex-1 tw-w-full"
          />
          <Button
            isLoading={isSubmitting}
            type="submit"
            additionalClassname="tw-rounded-l-none tw-rounded-r-full tw-border tw-border-v_blue-dark md:!tw-w-auto !tw-w-auto"
          >
            {btnSubmitText}
          </Button>
        </div>
      </div>
    </form>
  );
};
